import React, { useRef, useCallback, useEffect } from "react";
import { useCommandContext } from "utils/context/command";
import { KEYCODE_MAP } from "constants/keycode";
import VideoEmbed from "components/VideoEmbed";

export const useOnKeydown = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("keydown", listener);

    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [ref, handler]);
};

const CommandVideoEmbed = (props) => {
  const {
    actions: { popHistory }
  } = useCommandContext();
  const ref = useRef(null);

  const handleKeydown = (evt) => {
    const goBack =
      evt.keyCode === KEYCODE_MAP.BACKSPACE ||
      evt.keyCode === KEYCODE_MAP.ESCAPE;
    if (goBack) {
      popHistory();
    }
  };

  const onKeydown = useCallback((evt) => {
    handleKeydown(evt);
  }, []);
  useOnKeydown(ref, onKeydown);

  return (
    <span ref={ref}>
      <VideoEmbed {...props} />
    </span>
  );
};

export default CommandVideoEmbed;
